module.exports = __webpack_public_path__ + "static/media/illustration_payment-success.ea15cc4b.svg";